import Admin from '@/components/Admin/index'
import Login from '@/components/Admin/login/login'
import setPass from '@/components/Admin/login/setPass'
import bdPhone from '@/components/Admin/login/bdPhone'
import smSuccess from '@/components/Admin/login/smSuccess'
const router = [{
  path: '/login',
  name: '登录',
  component: Login
},
{
  path: '/setPass',
  name: '设置密码',
  component: setPass
},
{
  path: '/bdPhone',
  name: '首次扫码登录绑定手机号',
  component: bdPhone
},
{
  path: '/smSuccess',
  name: '后台扫码登录成功',
  component: smSuccess
},
{
  path: '/index',
  name: '后台首页',
  component: Admin,
  children: [{
    path: '/index',
    component: resolve =>
      require(['@/components/Admin/common/indexHome'], resolve),
    name: '主页'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/orderList',
    component: resolve => require(['@/components/Admin/order/list'], resolve),
    name: '订单列表'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/orderDetail',
    component: resolve => require(['@/components/Admin/order/detail'], resolve),
    name: '订单详情'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/merchantList',
    component: resolve => require(['@/components/Admin/merchant/list'], resolve),
    name: '商家列表'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/merchantRunning',
    component: resolve => require(['@/components/Admin/merchant/running'], resolve),
    name: '商家流水'
  }]
},
// {
//   path: '/',
//   name: 'home',
//   component: Admin,
//   hidden: true,
//   children: [{
//     path: '/merchantWarning',
//     component: resolve => require(['@/components/Admin/merchant/warning'], resolve),
//     name: '商家流失预警'
//   }]
// },
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/merchantRecharge',
    component: resolve => require(['@/components/Admin/merchant/recharge'], resolve),
    name: '商家充值'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/merchantReSuccess',
    component: resolve => require(['@/components/Admin/merchant/reSuccess'], resolve),
    name: '商家充值成功'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/merchantCapacity',
    component: resolve => require(['@/components/Admin/merchant/capacity'], resolve),
    name: '商家运力配置'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/merchantDiscount',
    component: resolve => require(['@/components/Admin/merchant/discount'], resolve),
    name: '商家折扣配置'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/agentList',
    component: resolve => require(['@/components/Admin/agent/list'], resolve),
    name: '代理商列表'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/agentRunning',
    component: resolve => require(['@/components/Admin/agent/running'], resolve),
    name: '代理商流水'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/agentAdd',
    component: resolve => require(['@/components/Admin/agent/add'], resolve),
    name: '添加代理商'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/agentRecharge',
    component: resolve => require(['@/components/Admin/agent/recharge'], resolve),
    name: '代理商充值'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/agentReSuccess',
    component: resolve => require(['@/components/Admin/agent/reSuccess'], resolve),
    name: '代理商充值成功'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/agentCapacity',
    component: resolve => require(['@/components/Admin/agent/capacity'], resolve),
    name: '代理商运力配置'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/agentDiscount',
    component: resolve => require(['@/components/Admin/agent/discount'], resolve),
    name: '代理商折扣配置'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/accountList',
    component: resolve => require(['@/components/Admin/power/accountList'], resolve),
    name: '员工账户列表'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/accountAdd',
    component: resolve => require(['@/components/Admin/power/accountAdd'], resolve),
    name: '添加员工账号'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/postList',
    component: resolve => require(['@/components/Admin/power/postList'], resolve),
    name: '员工职位列表'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/postAdd',
    component: resolve => require(['@/components/Admin/power/postAdd'], resolve),
    name: '添加员工职位'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/f_profitSummary',
    component: resolve => require(['@/components/Admin/finance/profitSummary'], resolve),
    name: '财务分润汇总'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/agentPolicy',
    component: resolve => require(['@/components/Admin/finance/agentPolicy'], resolve),
    name: '激励政策'
  }]
},
// {
//   path: '/',
//   name: 'home',
//   component: Admin,
//   hidden: true,
//   children: [{
//     path: '/f_profitDetail',
//     component: resolve => require(['@/components/Admin/finance/profitDetail'], resolve),
//     name: '财务分润明细'
//   }]
// },
// {
//   path: '/',
//   name: 'home',
//   component: Admin,
//   hidden: true,
//   children: [{
//     path: '/f_profitCount',
//     component: resolve => require(['@/components/Admin/finance/profitCount'], resolve),
//     name: '财务分润申请结算'
//   }]
// },
// {
//   path: '/',
//   name: 'home',
//   component: Admin,
//   hidden: true,
//   children: [{
//     path: '/f_countDetail',
//     component: resolve => require(['@/components/Admin/finance/countDetail'], resolve),
//     name: '财务分润申请结算明细'
//   }]
// },
// {
//   path: '/',
//   name: 'home',
//   component: Admin,
//   hidden: true,
//   children: [{
//     path: '/f_apply',
//     component: resolve => require(['@/components/Admin/finance/apply'], resolve),
//     name: '财务分润结算申请'
//   }]
// },
// {
//   path: '/',
//   name: 'home',
//   component: Admin,
//   hidden: true,
//   children: [{
//     path: '/f_applyRecord',
//     component: resolve => require(['@/components/Admin/finance/applyRecord'], resolve),
//     name: '财务分润结算申请记录'
//   }]
// },
// {
//   path: '/',
//   name: 'home',
//   component: Admin,
//   hidden: true,
//   children: [{
//     path: '/f_recordDetail',
//     component: resolve => require(['@/components/Admin/finance/recordDetail'], resolve),
//     name: '财务分润结算申请记录明细'
//   }]
// },
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/f_merchantRunning',
    component: resolve => require(['@/components/Admin/finance/merchantRunning'], resolve),
    name: '财务商家充值记录'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/f_summary',
    component: resolve => require(['@/components/Admin/finance/summary'], resolve),
    name: '财务资金池汇总'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/c_profitSummary',
    component: resolve => require(['@/components/Admin/capacity/profitSummary'], resolve),
    name: '运力分润汇总'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/c_profitDetail',
    component: resolve => require(['@/components/Admin/capacity/profitDetail'], resolve),
    name: '运力分润明细'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/c_profitCount',
    component: resolve => require(['@/components/Admin/capacity/profitCount'], resolve),
    name: '运力分润申请结算'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/c_countDetail',
    component: resolve => require(['@/components/Admin/capacity/countDetail'], resolve),
    name: '运力分润申请结算明细'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/c_apply',
    component: resolve => require(['@/components/Admin/capacity/apply'], resolve),
    name: '运力分润结算申请'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/c_applyRecord',
    component: resolve => require(['@/components/Admin/capacity/applyRecord'], resolve),
    name: '运力分润结算申请记录'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/c_recordDetail',
    component: resolve => require(['@/components/Admin/capacity/recordDetail'], resolve),
    name: '运力分润结算申请记录明细'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/c_capacityList',
    component: resolve => require(['@/components/Admin/capacity/list'], resolve),
    name: '运力列表'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/c_capacityAdd',
    component: resolve => require(['@/components/Admin/capacity/add'], resolve),
    name: '新建运力账户'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/c_storeLink',
    component: resolve => require(['@/components/Admin/capacity/storeLink'], resolve),
    name: '运力门店关联'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/systemStatus',
    component: resolve => require(['@/components/Admin/system/status'], resolve),
    name: '系统状态'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/systemSpace',
    component: resolve => require(['@/components/Admin/system/space'], resolve),
    name: '利润空间'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/systemMessage',
    component: resolve => require(['@/components/Admin/system/messageList'], resolve),
    name: '消息中心'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/messageAdd',
    component: resolve => require(['@/components/Admin/system/messageAdd'], resolve),
    name: '消息中心'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/userAllocation',
    component: resolve => require(['@/components/Admin/manage/userAllocation'], resolve),
    name: '用户分配'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/personAllocation',
    component: resolve => require(['@/components/Admin/manage/personAllocation'], resolve),
    name: '用户分配'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/shieldTransporter',
    component: resolve => require(['@/components/Admin/manage/shieldTransporter'], resolve),
    name: '屏蔽骑手'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/queryBill',
    component: resolve => require(['@/components/Admin/manage/queryBill'], resolve),
    name: '开票查询'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/statBD',
    component: resolve => require(['@/components/Admin/manage/statBD'], resolve),
    name: '员工业绩'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/statSellerOrders',
    component: resolve => require(['@/components/Admin/manage/statSellerOrders'], resolve),
    name: '员工业绩'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/statShopOrders',
    component: resolve => require(['@/components/Admin/manage/statShopOrders'], resolve),
    name: '门店业绩'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/orderCheck',
    component: resolve => require(['@/components/Admin/manage/orderCheck'], resolve),
    name: '订单核验'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/couponActivityList',
    component: resolve => require(['@/components/Admin/coupon/couponActivityList'], resolve),
    name: '活动管理'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/couponTakeList',
    component: resolve => require(['@/components/Admin/coupon/couponTakeList'], resolve),
    name: '优惠券领取列表'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/couponManage',
    component: resolve => require(['@/components/Admin/coupon/couponManage'], resolve),
    name: '优惠券管理'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/whitelist',
    component: resolve => require(['@/components/Admin/manage/whitelist'], resolve),
    name: '白名单'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/chainUsers',
    component: resolve => require(['@/components/Admin/manage/chainUser'], resolve),
    name: '开通连锁账号'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/bindApply',
    component: resolve => require(['@/components/Admin/manage/bindApply'], resolve),
    name: '绑定申请'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/shopModifyLog',
    component: resolve => require(['@/components/Admin/manage/shopLog'], resolve),
    name: '店铺更新记录列表'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/shopSFAuditLog',
    component: resolve => require(['@/components/Admin/manage/shopSFAuditLog'], resolve),
    name: '顺丰店铺审核'
  }]
},
{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/shareOrders',
    component: resolve => require(['@/components/Admin/finance/shareOrders'], resolve),
    name: '区域共享门店业绩'
  }]
},

{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/shopMTAuditLog',
    component: resolve => require(['@/components/Admin/manage/shopMTAuditLog'], resolve),
    name: '美团配送申请'
  }]
},

{
  path: '/',
  name: 'home',
  component: Admin,
  hidden: true,
  children: [{
    path: '/shopDaDaAuditLog',
    component: resolve => require(['@/components/Admin/manage/shopDaDaAuditLog'], resolve),
    name: '达达店铺审核'
  }]
},

]
export default router



// WEBPACK FOOTER //
// ./src/router/Admin/index.js